export default __webpack_public_path__ + "static/media/DSC_0527.ee29864a.webp";